<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      size="full-screen"
      :loading="loading"
      :visible.sync="modalVisible"
      :confirm-loading="confirmLoading"
      :contentStyle="{'height': '100%', 'display': 'flex', 'flex-direction': 'column'}"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>
      采购变更<span class="modal-secondary-title">{{purchaseOrder.code}}</span>
      <gj-tag
          type="plain"
          shape="rectangle"
          style="margin-left: 8px;"
          :color="purchaseOrder.status | optionColor(PurchaseOrderEnum.statusOption)">
        {{ purchaseOrder.status | optionText(PurchaseOrderEnum.statusOption) }}
      </gj-tag>
    </template>
    <template #content>
      <gj-area-title>基本信息</gj-area-title>
      <gj-desc-group
          :label-width="'90px'">
        <el-row :gutter="10">
          <el-col :span="4">
            <gj-desc
                label="采购仓"
                :content="purchaseOrder.deliveryWarehouseName">
            </gj-desc>
          </el-col>
          <el-col :span="4">
            <gj-desc
                label="供应商"
                :content="purchaseOrder.supplierName">
            </gj-desc>
          </el-col>
          <el-col :span="4">
            <gj-desc
                label="采购员"
                :content="purchaseOrder.supervisor">
            </gj-desc>
          </el-col>
          <el-col :span="4">
            <gj-desc
                label="结算方式">
              {{data.settlementWay | optionText(PurchaseOrderEnum.settleOption) | defaultShow}}
            </gj-desc>
          </el-col>
          <el-col :span="4">
            <gj-desc
                label="供应商联系人"
                :content="data.supplierContact">
            </gj-desc>
          </el-col>
          <el-col :span="4">
            <gj-desc
                label="联系人电话"
                :content="data.supplierContactPhone">
            </gj-desc>
          </el-col>
        </el-row>
        <el-row>
          <gj-desc
              label="备注">
            {{data.memo | defaultShow}}
          </gj-desc>
        </el-row>
        <el-row>
          <gj-desc
              label="已变更次数">
            {{data.changeNum || 0}}
          </gj-desc>
        </el-row>
      </gj-desc-group>
      <el-tabs value="product" :tab-position="'top'">
        <el-tab-pane label="产品明细" name="product">
          <app-purchase-change-product
              ref="purchaseChangeProductForm"
              :form="form"
              :purchase-order="purchaseOrder"
          ></app-purchase-change-product>
        </el-tab-pane>
        <el-tab-pane label="操作日志" lazy>
          <gj-log-table
              :url="`/supply/purchaseOrder/get/order/change/log/page`"
              :columns="PurchaseOrderEnum.logColumns"
              :params="{
                model: purchaseOrder.id
              }"
              adaptParent
              :offset-height="40"
              :min-height="390"
          ></gj-log-table>
        </el-tab-pane>
      </el-tabs>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn, responseMixin} from "@/minxins";
  import AppPurchaseChangeProduct from "./components/purchase-change-product";
  import {createPurchaseChangeOrder, getPurchaseOrder} from "@/api/purchase";
  import {PurchaseOrderEnum} from "../../enum";
  import {toFixed} from "@/utils/common";

  export default {
    name: "app-purchase-change-modal",
    components: {AppPurchaseChangeProduct},
    mixins: [modalMixIn, responseMixin],
    props: {
      purchaseOrder: {
        required: true
      }
    },
    data() {
      return {
        data: {},
        form: {
          items: []
        },
        loading: false,
        PurchaseOrderEnum: PurchaseOrderEnum
      }
    },
    created() {
      this.loading = true;
      this.form.items = this.purchaseOrder.products.map(item => ({
        ...item,
        newOrderQuantity: item.orderQuantity || null,
        newIncludeTaxPrice: item.includeTaxPrice ? toFixed(item.includeTaxPrice) : null,
        newAmount: null,
      }));
      getPurchaseOrder(this.purchaseOrder.id)
        .then(data => {
          this.data = data;
        })
        .complete(() => this.loading = false);
    },
    methods: {
      confirm() {
        if (this.$refs['purchaseChangeProductForm'].formValidate()) {
          const params = {
            id: this.purchaseOrder.id,
            products: this.form.items.map(product => ({
              id: product.id,
              newIncludeTaxPrice: product.newIncludeTaxPrice,
              newOrderQuantity: product.newOrderQuantity,
              changeMemo: product.memo
            }))
          };
          this.confirmLoading = true;
          createPurchaseChangeOrder(params)
            .then(res => {
              this.$gjResponseHandle(res, () => {
                this.$gjMessage.success('操作成功');
                this.$emit('created');
                this.$gjDestroy();
              });
            })
            .complete(() => this.confirmLoading = false);
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
/deep/ .el-tabs{
  flex: 1;
  overflow: auto;
  display: flex;
  flex-direction: column;
  .el-tabs__content{
    flex: 1;
    overflow: auto;
  }
  .el-tab-pane{
    height: 100%;
  }
}
/deep/ .el-tabs__header{
  margin-bottom: 12px;

}
/deep/ .gj-area-title{
  margin-bottom: 5px;
}
/deep/ .el-dialog__body{
  padding: 16px 20px 0;
}

</style>
